/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const LOAD_FAVORITES = 'boilerplate/FavoritePage/LOAD_FAVORITES';
export const FAVORITES_LOADED  = 'boilerplate/FavoritePage/FAVORITES_LOADED';
export const SET_LOADING  = 'boilerplate/FavoritePage/SET_LOADING';
export const SET_FILTER  = 'boilerplate/FavoritePage/SET_FILTER';
export const TO_LIST = 'boilerplate/FavoritePage/TO_LIST';
export const TO_MASONRY = 'boilerplate/FavoritePage/TO_MASONRY';
